<template>
  <div class="auth-contact-developers">
    <slot name="trigger" :open="handleOpen">
      <BaseButton
        type="button"
        size="sm"
        rounded
        flat
        variant="light"
        data-testid="auth-write-developers-btn"
        @click="handleOpen"
      >
        {{ t('Написать разработчикам') }}
      </BaseButton>
    </slot>
    <AuthContactDevelopersPopup
      v-model="isPopupOpen"
      :sender-email="props.senderEmail"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { BaseButton } from '~/shared/ui'
import i18n from './AuthContactDevelopersBlock.i18n.json'
import AuthContactDevelopersPopup from './AuthContactDevelopersPopup.vue'

const props = defineProps<{
  senderEmail?: string | null
}>()

const { t } = useI18n(i18n)

const isPopupOpen = ref(false)

function handleOpen() {
  isPopupOpen.value = true
}
</script>

<style scoped lang="scss">
.auth-contact-developers {
  display: flex;
  width: 100%;
  justify-content: center;

  &:deep(.base-button) {
    border: 2px solid #ff563f33;
  }
}
</style>
